module.exports = __WEBPACK_EXTERNAL_MODULE_224__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Pikaday","commonjs2":"pikaday","commonjs":"pikaday","amd":"pikaday"}
// module id = 224
// module chunks = 0